module.exports = __webpack_public_path__ + "media/images/bpi-eda30348cd30ddb8f678c7ad2f01273a.png";